module.exports = __webpack_public_path__ + "img/elite-background.2b9b285c.png";